module.exports = __webpack_public_path__ + "static/image/company/pc/image_vision_3@3x.jpg?d34230c4";